// import firebase from 'firebase/app';
import db from "@/firebase/init";

export default {
  methods: {
    getFirestoreData(uid) {

      // Populate store with data from firestore
      let docRef = db.collection('users').doc(uid);
      docRef.get().then(doc => {
        if (doc.exists) {

          let standardExerciseScores = doc.data()['standardExerciseScores'];
          // let gameSettings = doc.data()['gameSettings'];

          let userExercises = {
            userLevelsCompareIntervalSizes: doc.data()['userLevelsCompareIntervalSizes'],
            userLevelsIdentifyChordInversions: doc.data()['userLevelsIdentifyChordInversions'],
            userLevelsIdentifyChords: doc.data()['userLevelsIdentifyChords'],
            userLevelsIdentifyIntervals: doc.data()['userLevelsIdentifyIntervals'],
            userLevelsIdentifyScales: doc.data()['userLevelsIdentifyScales']
          }

          this.$store.dispatch('setAllStandardExerciseScores', standardExerciseScores);
          // Stored locally
          // this.$store.dispatch('setTimeIntervalBetweenNotes', gameSettings['timeInterval']);
          // this.$store.dispatch('setAutoContinue', gameSettings['autoContinue']);
          // this.$store.dispatch('setVolume', gameSettings['volume']);
          // this.$store.dispatch('setPlayScaleOctave', gameSettings['playScaleOctave']);
          // this.$store.dispatch('setPlayableKeyboard', gameSettings['playableKeyboard']);
          // this.$store.dispatch('setAnswerSound', gameSettings['answerSound']);
          
          
          this.$store.dispatch('setAllUserExercises', userExercises);
          // Initialize all selected levels after user levels have been added from database
          this.$store.dispatch('initializeSelectedLevels');
          

        } else {
          this.$store.dispatch('initializeSelectedLevels');
        }
      })

    }
  }
}


